import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Comparison from './components/ExecutiveCharts';
import Dashboard from './components/ExecutiveDashboardContainer';
import ScheduleApprovals from './components/ScheduleApprovals';
import ScheduleApproval from './components/ScheduleApproval';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Trip_Fees from "../managers/components/Trip_Fees";

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}/comparison`}>
				<Comparison regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Dashboard regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/approvals`}>
				<ScheduleApprovals regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/approvals/:id`}>
				<ScheduleApproval regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
